import { Controller } from "stimulus";
import OpSelect from "~/scripts/components/OpSelect";

export default class extends Controller {
    opened = false;

    static targets = ["select", "form"];

    initialize() {
        this.submit = this.submit.bind(this);
    }

    connect() {
        this.opSelect = new OpSelect({
            el: this.element,
            textClass: "dropdown__text",
            textInnerClass: "dropdown__text-inner",
            select: this.selectTarget,
            onChangeCallback: this.submit
        });
    }

    submit() {
        this.formTarget.submit();
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/dropdown_controller.js